import { createRef, RefObject } from 'react';
import { CLOSE_MODAL, OPEN_MODAL } from './ModalActions';

const INITIAL_STATE = {
  ModalManagerRef: createRef<any>(),
};

export interface ModalReducerType {
  ModalManagerRef: RefObject<any>;
}

export default function ModalReducer(
  state = INITIAL_STATE,
  action: any
): ModalReducerType {
  if (action.type === OPEN_MODAL) {
    state.ModalManagerRef.current.openModal(
      action.payload.component,
      action.payload.props
    );
  } else if (action.type === CLOSE_MODAL) {
    state.ModalManagerRef.current.closeModal(action.payload.key);
  }
  return state;
}
